/**
 * AC-AI-CHIPS (BuildNotes P3) — «Часті питання» = СТАТИЧНИЙ кураторський список
 * (0 телеметрії/персоналізації у P0). У drawer — module-aware за routeKey.
 *
 * Питання навмисно сформульовані як CRM-how-to (не про дані клієнтів) — рівно
 * те, що покриває verified-KB. Якщо модуль не покритий → асистент чесно
 * відповість no-coverage (sources-gate), тож «мертвих» чіпів немає.
 */

/** KB-екран — загальний кураторський набір (мокап v2). */
export const KB_CURATED_CHIPS: string[] = [
  "Як закрити зустріч звітом?",
  "Чому не можу створити зустріч?",
  "Що таке «Очікує уточнення»?",
  "Як заповнити профіль клієнта?",
  "Куди подати запит у Фінанси?",
];

/** Drawer — module-aware за routeKey (лише теми з verified-KB). */
const MODULE_CHIPS: Record<string, string[]> = {
  contracts: ['Що таке «Активні в роботі»?', 'Що значить «без юрособи»?'],
  contract: ['Що таке «Активні в роботі»?', 'Що значить «без юрособи»?'],
  tasks: ["Як створити задачу?", "Що таке обіцянка оплати?"],
  meetings: ["Як закрити зустріч звітом?", "Чому кнопка зустрічі неактивна?"],
  requests: ["Куди подати запит у Фінанси?", "Що таке route-preview?"],
  contacts: ["Хто може об'єднувати дублікати контактів?", "Як зробити контакт основним?"],
  complaints: ["Як створити рекламацію?", "Хто бачить чергу рекламацій?"],
  clients: ["Як заповнити профіль клієнта?", "Що таке «Потребує перевірки»?"],
  client: ["Як заповнити профіль клієнта?", "Чому дані з 1С лише читаються?"],
  "needs-review": ["Що таке «Потребує перевірки»?", "Хто підтверджує профіль?"],
};

/** Загальний fallback для drawer, коли модуль без кураторських чіпів. */
const DRAWER_DEFAULT_CHIPS: string[] = [
  "Як працює цей розділ?",
  "Чому кнопка неактивна?",
];

export function drawerChips(routeKey?: string | null): string[] {
  if (routeKey && MODULE_CHIPS[routeKey]) return MODULE_CHIPS[routeKey];
  return DRAWER_DEFAULT_CHIPS;
}
